import { useEffect, useState } from "react"
import { useParams } from 'react-router-dom';
import AutocompleteInput from "../../shared/components/AutocompleteInput"
import CoorayAppBar, { NavigationButtonType } from "../../shared/components/CoorayAppBar"
import FilterChipsContainer from "../../shared/components/FilterChipsContainer"
import PlaceRepository from "../../repository/PlaceRepository";
import GoogleRepository from "../../repository/GoogleRepository"
import CurationRepository from "../../repository/CurationRepository";
import { createClient } from '@supabase/supabase-js'
import EditPlaceSuccessPage from "./EditPlaceSuccessPage";
import { useNavigate } from 'react-router-dom';
import CoorayFooter from "../../shared/components/footer/CoorayFooter";
import AnotherCurationItem from "../placedetails/AnotherCurationItem";
import { AnalyticsEvent } from "../../shared/analytics/AnalyticsEvent";
import { Helmet } from "react-helmet";
import EmojiPicker from "emoji-picker-react";
import { usePlaceDetailsContext } from "../placedetails/PlaceDetailsContext";
import { useCurationContext } from "../curation/CurationContext";
import { isValidHttpUrl } from "../../shared/utils/StringUtils";
import FeedbackButton from "../../shared/components/feedback/FeedbackButton";
import { sendPageView } from "../../shared/utils/AnalyticsUtils";

const supabase = createClient('https://twblyxzvdbhlhxxurpno.supabase.co', 'eeyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR3Ymx5eHp2ZGJobGh4eHVycG5vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAzNDMzNTMsImV4cCI6MjA3NTkxOTM1M30.cOz8DeHN7L00i3VN2wF5NXs2quw95Eaz3-8IQs4ltgw')

export default function EditPlacePage({ analytics }) {

    const [editingPlaceDetails, setEditingPlaceDetails] = useState(null)
    const {placeDetails, setPlaceDetails} = usePlaceDetailsContext()
    const {curationData, setCurationData} = useCurationContext()
    const [selectedFilterOptionIds, setSelectedFilterOptionIds] = useState([])
    const [editingCurationData, setEditingCurationData] = useState(null)
    const [searchTerm, setSearchTerm] = useState('')
    const [searchUrl, setSearchUrl] = useState('')
    const [searchPredictions, setSearchPredictions] = useState([])
    const [selectedPlace, setSelectedPlace] = useState(null)
    const [autocompleteLoadingText, setAutocompleteLoadingText] = useState(null)
    const [loadingText, setLoadingText] = useState(null)
    const [updateSuccessPlace, setUpdateSuccessPlace] = useState(null)
    const [currentPage, setCurrentPage] = useState(0)
    const [inputDescription, setInputDescription]= useState("")
    const [emoji, setEmoji] = useState(null)
    const [isUsingCurationEmoji, setIsUsingCurationEmoji] = useState(false)
    const { placeId }= useParams()
    const navigate = useNavigate()

    useEffect(() => {
      const placeRepository = new PlaceRepository()
      const curationRepository = new CurationRepository()

      async function getPlaceDetails(id) {
        setLoadingText("Loading ...")
        const {
          data: { user },
        } = await supabase.auth.getUser()
        if (user == null) {
          navigate("/login", {replace: true})
        } else {
          let details
          if (placeDetails && placeDetails.id == id) {
            details = placeDetails
          } else {
            details = await placeRepository.getPlaceDetails(id)
          }
          console.log(details)
          setEditingPlaceDetails(details)
          console.log(`comparing users ${user.id} ${details.authorUserId}`)
          let curation
          if (curationData.curation.id == details.curationId) {
            curation = curationData
          } else {
            curation = await curationRepository.getCurations(details.curationId)
          }
          console.log(curation)
          setEditingCurationData(curation)
          setSelectedFilterOptionIds(details.filterOptions.map((placeSelectedFilterOption) => placeSelectedFilterOption.id))
          setEmoji(details.emoji)
          console.log(`emoji ${details.emoji}`)
          setIsUsingCurationEmoji(!details.emoji)
          setLoadingText(null)
          setSearchTerm(details.title)
        }
      }
      
      getPlaceDetails(placeId)

      sendPageView(analytics, AnalyticsEvent.EDIT_PLACE_VIEW, {
        place_id: placeId
      })

    }, [placeId])

    useEffect(() => {
      async function decodePlace(input) {
        const googleRepository = new GoogleRepository()
        try {
          const response = await googleRepository.getPlaceIdFromShareUrl(input)
          handlePlaceItemSelected(
            {
              label: response.googlePlace.structured_formatting.main_text,
              secondaryLabel: response.googlePlace.structured_formatting.secondary_text,
              key: response.googlePlace.place_id,
              link: "#"
            }
          )
          setAutocompleteLoadingText(null)
        } catch(e) {
          setAutocompleteLoadingText(null)
        }
      }
  
      const delayDebounceFn = setTimeout(() => {
        console.log(searchUrl)
        if (searchUrl) {
          decodePlace(searchUrl)
        }
      }, 1500)
  
      return () => clearTimeout(delayDebounceFn)
    }, [searchUrl])

    useEffect(() => {
      const googleRepository = new GoogleRepository()

      async function getPlacesAutocomplete(input) {
        const places = await googleRepository.getPlacesAutocomplete(input)
        console.log(places)
        setSearchPredictions(
          places.predictions.map((prediction) => {
            return {
              label: prediction.structured_formatting.main_text,
              secondaryLabel: prediction.structured_formatting.secondary_text,
              key: prediction.place_id,
              link: "#"
            }
          })
        )
        setAutocompleteLoadingText(null)
      }
  
      const delayDebounceFn = setTimeout(() => {
        console.log(searchTerm)
        if (searchTerm) {
          getPlacesAutocomplete(searchTerm)
        }
      }, 1500)
  
      return () => clearTimeout(delayDebounceFn)
    }, [searchTerm, placeId])

    function handlePlaceInputChange(event) {
      setAutocompleteLoadingText("Loading ...")
      setSelectedPlace(null)
      setSearchPredictions([])
      const searchString = event.target.value
      if (isValidHttpUrl(searchString)) {
        setSearchTerm(null)
        setSearchUrl(searchString)
      } else {
        setSearchUrl(null)
        setSearchTerm(searchString)
      }
    }

    function handleDescriptionChange(event) {
      setInputDescription(event.target.value)
    }

    function handlePlaceItemSelected(item) {
      setSelectedPlace(item)
      setSearchPredictions([])
    }

    function onBackPressed() {
      window.history.back()
    }

    function onFilterOptionClick(filterOption) {
      console.log(`${JSON.stringify(filterOption)} clicked`)
      if (selectedFilterOptionIds.includes(filterOption.id)) {
        setSelectedFilterOptionIds(selectedFilterOptionIds.filter((id) => id != filterOption.id))
      } else {
        setSelectedFilterOptionIds(selectedFilterOptionIds.concat([filterOption.id]))
      }
    }

    async function savePlace() {
      setLoadingText("Saving ...")
      const placeRepository = new PlaceRepository(supabase)
      const updatedPlace = await placeRepository.updatePlace(
          editingPlaceDetails.id,
          selectedPlace?.label,
          selectedPlace?.key,
          selectedFilterOptionIds,
          inputDescription,
          emoji,
          isUsingCurationEmoji
      )
      setUpdateSuccessPlace(updatedPlace)
      setCurrentPage(1)
    }

    function onUsingCurationEmojiChange(event) {
      const {checked} = event.target;
      console.log(`ischecked ${checked}`)
      setIsUsingCurationEmoji(checked)
    }


    function onEmojiClick(emojiData, _) {
        console.log(emojiData)
        setEmoji(
            emojiData.emoji
        )
        document.getElementById(`pick-emoji-modal`).close();
    }

  if (currentPage == 0) {
    return (
        <div className="min-h-screen">
          <Helmet><title>Editing Place</title></Helmet>
        <CoorayAppBar title={"Edit Place"} onBackPressed={onBackPressed} navigationType={NavigationButtonType.Back}/>
        <div className="pb-24">
          <div className="form-control w-full px-4 py-4">
            <label className="label">
              <span className="label-text font-bold text-sm">Search for a place</span>
            </label>
            <AutocompleteInput 
                placeholder={"Type here ..."}
                onValueChange={handlePlaceInputChange}
                items={ searchPredictions }
                value={ selectedPlace?.label ?? searchTerm }
                onItemSelected={handlePlaceItemSelected}
                loadingText={autocompleteLoadingText}
                />
          </div>
          {/* <div className="form-control w-full px-4 py-4">
            <label className="label">
              <span className="label-text font-bold text-sm">Description</span>
            </label>
            <div className="py-4 flex items-center">
            <input type="checkbox" checked={isUsingAIDescription} className="checkbox checkbox-primary" onChange={onAIDescriptionInputChange}/>
            <svg className="w-10 h-10 ml-2" viewBox="0 -0.5 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path className="stroke-base-content" fillRule="evenodd" clipRule="evenodd" d="M4.5 14.462V12.538C4.52129 11.6681 5.2431 10.9799 6.113 11H6.774C7.34208 9.24261 8.96147 8.03831 10.808 8H14.192C16.0385 8.03831 17.6579 9.24261 18.226 11C18.4082 11.5231 18.5009 12.0731 18.5 12.627V14.373C18.5849 16.8392 16.6579 18.9088 14.192 19H10.808C8.96147 18.9617 7.34208 17.7574 6.774 16H6.113C5.2431 16.0201 4.52129 15.3319 4.5 14.462Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path className="stroke-base-content" d="M13.25 5C13.25 4.58579 12.9142 4.25 12.5 4.25C12.0858 4.25 11.75 4.58579 11.75 5H13.25ZM11.75 8C11.75 8.41421 12.0858 8.75 12.5 8.75C12.9142 8.75 13.25 8.41421 13.25 8H11.75ZM6.06579 16.2467C6.20206 16.6379 6.62963 16.8445 7.02079 16.7082C7.41194 16.572 7.61856 16.1444 7.48228 15.7533L6.06579 16.2467ZM6.50004 14.373L7.25004 14.3742V14.373H6.50004ZM6.50004 12.627H7.25004L7.25004 12.6258L6.50004 12.627ZM7.48228 11.2467C7.61856 10.8556 7.41194 10.428 7.02079 10.2918C6.62963 10.1555 6.20206 10.3621 6.06579 10.7533L7.48228 11.2467ZM18.226 10.25C17.8118 10.25 17.476 10.5858 17.476 11C17.476 11.4142 17.8118 11.75 18.226 11.75V10.25ZM18.887 11V11.75C18.8928 11.75 18.8986 11.7499 18.9044 11.7498L18.887 11ZM20.5 12.538H21.25C21.25 12.5319 21.25 12.5258 21.2498 12.5197L20.5 12.538ZM20.5 14.462L21.2498 14.4803C21.25 14.4742 21.25 14.4681 21.25 14.462H20.5ZM18.887 16L18.9044 15.2502C18.8986 15.2501 18.8928 15.25 18.887 15.25V16ZM18.226 15.25C17.8118 15.25 17.476 15.5858 17.476 16C17.476 16.4142 17.8118 16.75 18.226 16.75V15.25ZM10.5 15.75C10.0858 15.75 9.75004 16.0858 9.75004 16.5C9.75004 16.9142 10.0858 17.25 10.5 17.25V15.75ZM14.5 17.25C14.9142 17.25 15.25 16.9142 15.25 16.5C15.25 16.0858 14.9142 15.75 14.5 15.75V17.25ZM11.75 5V8H13.25V5H11.75ZM7.48228 15.7533C7.32782 15.3099 7.2493 14.8437 7.25004 14.3742L5.75004 14.3718C5.74904 15.0101 5.85579 15.644 6.06579 16.2467L7.48228 15.7533ZM7.25004 14.373V12.627H5.75004V14.373H7.25004ZM7.25004 12.6258C7.2493 12.1563 7.32782 11.6901 7.48228 11.2467L6.06579 10.7533C5.85579 11.356 5.74904 11.9899 5.75004 12.6282L7.25004 12.6258ZM18.226 11.75H18.887V10.25H18.226V11.75ZM18.9044 11.7498C19.3606 11.7392 19.7391 12.1002 19.7503 12.5563L21.2498 12.5197C21.2184 11.2361 20.1533 10.2205 18.8697 10.2502L18.9044 11.7498ZM19.75 12.538V14.462H21.25V12.538H19.75ZM19.7503 14.4437C19.7391 14.8998 19.3606 15.2608 18.9044 15.2502L18.8697 16.7498C20.1533 16.7795 21.2184 15.7639 21.2498 14.4803L19.7503 14.4437ZM18.887 15.25H18.226V16.75H18.887V15.25ZM10.5 17.25H14.5V15.75H10.5V17.25Z"/>
            </svg>
            <div className="pl-2">
            <div className="font-bold">Use AI generated description</div>
            <div>Select this if you do not have a description for this place, and would like to us Cooray AI to generate one.</div>
            </div>
            </div>
            {!isUsingAIDescription && <textarea value={inputDescription} className="textarea textarea-bordered h-32 text-base rounded-md" placeholder="Write your description here..." onChange={handleDescriptionChange}></textarea>}
          </div> */}
          {
            editingCurationData && <div className="px-4 w-full md:max-w-lg flex flex-col">
              <span className="font-bold text-sm pb-2">Added to collection</span>
            <AnotherCurationItem 
              title={editingCurationData.curation.title}
              description={editingCurationData.curation.description}
              emoji={editingCurationData.curation.emoji}
              imageUrl={editingCurationData.curation.coverPhoto}
              onClick={() => {}}
            />
            </div>
            
          }
          {
            editingPlaceDetails && editingCurationData && editingCurationData.filters.map((filter) => {
              return <FilterChipsContainer 
                modifier={"px-4 py-4"}
                key={filter.id}
                title={filter.label}
                filterOptions={
                  filter.filterOptions.map((option) => {
                    return { ...option, isSelected: selectedFilterOptionIds.includes(option.id) }
                  })
                }
                onFilterOptionClick={onFilterOptionClick}
              />
            })
          }
          {
            <div className="form-control w-full px-4 py-4">
              <label className="label">
                <span className="label-text font-bold text-base">Place emoji</span>
              </label>
              <div className="py-4 flex items-center">
                <input type="checkbox" checked={isUsingCurationEmoji} className="checkbox checkbox-primary" onChange={onUsingCurationEmojiChange}/>
                <div className="pl-2">
                  <div className="font-normal">Use default collection emoji</div>
                </div>
              </div>
              <div className="avatar">
                <div className="rounded-full bg-base-200 p-4 w-36 text-center flex place-content-center">
                    <div className='font-bold text-6xl'>{
                      isUsingCurationEmoji && editingCurationData.curation.emoji
                    }{
                      !isUsingCurationEmoji && emoji
                    }</div>
                </div>
              </div>
              {!isUsingCurationEmoji && 
                  <div className='pt-4 w-36 text-center'>
                      <button className="btn btn-primary normal-case w-auto" onClick={() => {
                          document.getElementById(`pick-emoji-modal`).showModal();
                      }}>Pick emoji</button>
                  </div>
              }
            </div>
          }
        </div>
        <div className='fixed bottom-0 right-4 pb-4 w-full text-center'>
          <button className="btn btn-success normal-case ml-4" onClick={() =>{ savePlace() }}>
          <svg className="w-6 h-6" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
            <path className="stroke-success-content" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.828a2 2 0 0 0-.586-1.414l-1.828-1.828A2 2 0 0 0 16.172 4H15M8 4v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V4M8 4h7M7 17v-3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3"/>
          </svg>
            Save
          </button>
        </div>
        <CoorayFooter />
        {loadingText &&
          <div className='w-full h-screen fixed top-0 flex flex-col items-center justify-center backdrop-blur-sm bg-base-100/30'>
              <div className="loading loading-infinity loading-lg"></div>
              <div className='font-normal text-base-content mt-2'>{loadingText}</div>
          </div>
        }
        <dialog id="pick-emoji-modal" className="modal">
            <div className="modal-box w-11/12 max-w-5xl">
                <h3 className="font-bold text-lg pb-4">Pick Marker Emoji</h3>
                <EmojiPicker width={"100%"} theme={window.matchMedia('(prefers-color-scheme: dark)').matches ? "dark": "light"} onEmojiClick={onEmojiClick} searchDisabled={true}/>
                <div className="modal-action">
                    <button className="btn btn-ghost" onClick={() => { document.getElementById("pick-emoji-modal").close() }}>Cancel</button>
                </div>
            </div>
        </dialog>
        {
          <FeedbackButton />
        }
      </div>
    )
  } else {
    return (
      <EditPlaceSuccessPage addedPlaceData={updateSuccessPlace} curationData={editingCurationData}/>
    )
  }
}
